<!-- <mat-card class="mat-elevation-z8">

    <mat-card-subtitle>Level Status</mat-card-subtitle>

    <mat-card-content>


        <mat-list>
            <mat-list-item *ngFor="let level of levels">
                
                <mat-form-field class="form-element">
                    <input matInput value="{{level}}" readonly>
                    <button mat-button matSuffix mat-icon-button [matMenuTriggerFor]="menu">
                        +
                    </button>
                </mat-form-field>

                <mat-menu #menu="matMenu">
                    <div class="row p-2" style="margin: 0;">
                        <div mat-menu-item class="col-sm-6 hover-effect" data-toggle="tooltip" data-placement="bottom" title="Purple Theme" style="padding: 0;">
                            <div class="color-container" (click)="pickColor('purple-theme',level)">
                                <div class="colorDiv color-purple"></div>
                            </div>
                        </div>
                        <div mat-menu-item class="col-sm-6 hover-effect" data-toggle="tooltip" data-placement="bottom" title="Blue Theme" style="padding: 0;">
                            <div class="color-container" (click)="pickColor('blue-theme',level)">
                                <div class="colorDiv color-blue"></div>
                            </div>
                        </div>
                    </div>
                    <div class="row p-2" style="margin: 0;">
                        <div mat-menu-item class="col-sm hover-effect" data-toggle="tooltip" data-placement="bottom" title="Red Theme" style="padding: 0;">
                            <div class="color-container">
                                <div class="colorDiv color-red" (click)="pickColor('red-theme',level)"></div>
                            </div>
                        </div>
                        <div mat-menu-item class="col-sm hover-effect" data-toggle="tooltip" data-placement="bottom" title="Violet Theme" style="padding: 0;">
                            <div class="color-container">
                                <div class="colorDiv color-violet" (click)="pickColor('violet-theme',level)"></div>
                            </div>
                        </div>
                    </div>
                </mat-menu>

            </mat-list-item>

        </mat-list>

        <mat-action-row>
            <button mat-button (click)="openLink($event)" color="primary">X</button>
        </mat-action-row>
    </mat-card-content>
</mat-card> -->

<mat-card class="mat-elevation-z8">
    <mat-card-subtitle>Fill out Control Option</mat-card-subtitle>
    <mat-card-content>
        <form [formGroup]="optionForm" (ngSubmit)="onSubmit()">

            <mat-form-field class="form-element">
                <input matInput placeholder="Label" formControlName="label" required>
            </mat-form-field>
            
            <mat-form-field class="form-element">
                <input matInput placeholder="Value" formControlName="value" required>
            </mat-form-field>

            <mat-action-row>
                <span style="flex: 1 1 auto"></span>
                <button mat-button color="primary" type="submit" [disabled]="!optionForm.valid">Add Control
                    Option</button>
            </mat-action-row>
        </form>
    </mat-card-content>
</mat-card>